import { FC, useCallback, useState } from "react"
import { iosBuildDeleteApi } from "src/domain/api/iosBuild/iosBuildDeleteApi"
import { IosBuild } from "src/domain/entities/iosBuild"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	iosBuild: IosBuild
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const IosBuildDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	iosBuild,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleIosBuildDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await iosBuildDeleteApi({ id: iosBuild.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [iosBuild, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Ios Build: ${iosBuild.version}(${iosBuild.buildNo})`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleIosBuildDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
